import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { GetUsersForOutboundModalEmployeeTableQuery } from '@api/generated/graphql';

export const getUsersForOutboundModalEmployeeTableQuery = graphql(`
  query getUsersForOutboundModalEmployeeTable {
    users {
      items {
        id
        name
        email
        personalLine {
          phoneNumber
        }
      }
      totalCount
    }
  }
`);

export type UserQueryItem = Exclude<
  Exclude<
    GetUsersForOutboundModalEmployeeTableQuery['users'],
    undefined | null
  >['items'],
  undefined | null
>[0];

export const getUsersForOutboundModalEmployeeTable = async (): Promise<
  UserQueryItem[]
> => {
  const { data, error } = await getClient().query({
    query: getUsersForOutboundModalEmployeeTableQuery,
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.users?.items ?? [];
};
